/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import { Alert, Button } from '@piggytechng/component-library';
import { OverideButtonStyle } from '../../helpers/utils';
import useProcessor from '../../hooks/useProcessor';
import { useState } from 'react';
import ModalExecuteAction from './ModalExecuteAction';

function ModalToggleProcessorStatus({ modalIsOpen, setIsOpen, data, action }: ModalProps) {
  const { toggleProcessorStatus, isLoading } = useProcessor();
  const [showActionModal, setShowActionModal] = useState(false);

  function closeModal() {
    if (isLoading.toggleProcessorStatus) return;
    setIsOpen(false);
  }

  const handleSubmit = () => {
    toggleProcessorStatus(data?.provider, !data?.status, () => {
      Alert.success(`${data?.provider} has been ${data?.status ? 'disabled' : 'enabled'} successfully`);
      closeModal();
      action && action();
    }).catch(() => {
      setShowActionModal(false);
      setIsOpen(true);
    });
  };

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <div className={`modal-processor`}>
          <div className="modal-processor__header">
            <button onClick={closeModal}>&times;</button>
          </div>
          <h2>{data?.status ? 'Disable' : 'Enable'} Provider</h2>
          <span className="modal-processor__sub-text">
            Are you sure you want to {data?.status ? 'disable' : 'enable'} <b>{data?.provider}</b>?
          </span>

          <form
            className="modal-processor__body"
            onSubmit={(e) => {
              e.preventDefault();
              setShowActionModal(true);
              setIsOpen(false);
            }}
          >
            <div className="modal-processor__actions">
              <button className="modal-processor__actions-reject" type="button" onClick={() => closeModal()}>
                Cancel
              </button>

              <Button
                {...OverideButtonStyle}
                className="modal-processor__actions-resolve"
                type="submit"
                loading={isLoading.toggleProcessorStatus}
              >
                Confirm
              </Button>
            </div>
          </form>
        </div>
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showActionModal}
        isLoading={isLoading.toggleProcessorStatus}
        setIsOpen={setShowActionModal}
        text={data?.status ? 'disable this provider?' : 'enable this provider?'}
        action={() => handleSubmit()}
        actionColor="#1734CA"
        buttonText={data?.status ? 'Disable' : 'Enable'}
      />
    </>
  );
}

export default ModalToggleProcessorStatus;
